import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { MarcacaoDTO } from '../../../dtos/marcacao-dto';
import { PacienteDTO } from '../../../dtos/paciente-dto';
import { MarcacaoConsulta } from '../../../marcacao/marcacao-consulta/marcacao-consulta';
import { MarcacaoConsultaService } from '../../../marcacao/marcacao-consulta/marcacao-consulta.service';
import { ServicosUtilidadesService } from '../../../servicos-utilidades/servicos-utilidades.service';

@Component({
  selector: 'app-selecionar-marcacao-consulta-para-reenvio-comprovante',
  templateUrl: './selecionar-marcacao-consulta-para-reenvio-comprovante.component.html',
  styleUrls: ['./selecionar-marcacao-consulta-para-reenvio-comprovante.component.css']
})
export class SelecionarMarcacaoConsultaParaReenvioComprovanteComponent implements OnInit {

  pacienteSelecionado: PacienteDTO;

  formularioDeReenvioComprovanteSelecionarMarcacao: FormGroup;

  listaMarcacoes: Array<MarcacaoDTO> = [];

  constructor(private marcacaoService: MarcacaoConsultaService,
    private servicosUtilidadesService: ServicosUtilidadesService,
    private router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog) {

    this.pacienteSelecionado = Object.assign(new PacienteDTO(), history.state.pacienteSelecionado);

    this.formularioDeReenvioComprovanteSelecionarMarcacao = this.formBuilder.group({
      nome: [''],
      foneCelular: ['', [Validators.required]],
    });
  }

  ngOnInit() {

    this.listarAgendamentosDoPacienteComProjecao();

    this.configurarForm();
  }

  configurarForm(): void {

    this.formControl.nome.setValue(this.pacienteSelecionado.nome);

    this.formControl.nome.disable();

  }

  onSubmit() {
    this.reenviarComprovante();
  }

  listarAgendamentosDoPacienteComProjecao(): void {

    this.marcacaoService.listarAgendamentosDoPacienteComProjecao(this.pacienteSelecionado.id)
      .subscribe(data => {

        this.listaMarcacoes = [];

        data.forEach((element: any) => {
          this.listaMarcacoes.push(Object.assign(new MarcacaoDTO(), element));
        });

      }, error => {
        console.log(error);
      });
  }

  reenviarComprovante() {

    let marcacaoSelecionada: MarcacaoDTO = this.obterMarcacaoSelecionada();
    let foneCelular: string = this.formControl.foneCelular.value;

    if (marcacaoSelecionada && foneCelular) {

      this.marcacaoService.procurarPorPk(marcacaoSelecionada.getPkConsultaDaEntidade())
        .subscribe(data => {

          const marcacaoAtual: MarcacaoConsulta = Object.assign(new MarcacaoDTO(), data);

          if (marcacaoAtual) {

            this.servicosUtilidadesService.enviarSMSAgendamentoConsulta(marcacaoAtual, foneCelular)
              .subscribe(data => {
                // console.log(data)

                const dialogRef = this.dialog.open(InfoDialogComponent, {
                  data: {
                    title: 'Info',
                    message: 'SMS enviado com sucesso!'
                  }
                });

                dialogRef.afterClosed().subscribe(result => {
                  this.gotoList();
                });
              }, error => {
                console.log(error);
              });

          } else {
            this.dialog.open(ErrorDialogComponent, {
              data: {
                title: 'Erro',
                message: 'Reenvio não realizado. Marcação não encontrada!'
              }
            });
          }
        }, error => {
          console.log(error);
        });
    } else {

      let msgErro: string = 'Reenvio não realizado. Erro interno.';

      if (!marcacaoSelecionada && !foneCelular) {
        msgErro = 'Reenvio não realizado. Selecione uma marcação e preencha um telefone válido!';
      } else if (!marcacaoSelecionada) {
        msgErro = 'Reenvio não realizado. Selecione uma marcação!';
      } else if (!foneCelular) {
        msgErro = 'Reenvio não realizado. Preencha um telefone válido!';
      } else {
        msgErro = 'Reenvio não realizado. Erro interno.';
      }

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: msgErro
        }
      });
    }
  }

  gotoList() {
    this.router.navigate(['/reenvioComprovanteProcurarPaciente'], {
      state: {
        filtroPaciente: history.state.filtroPaciente,
        tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
      }
    });
  }

  selecionarMarcacao(marcacao: MarcacaoDTO): void {

    this.limparSelecao();

    if (this.listaMarcacoes) {
      let marcacaoParaSelecionar: MarcacaoDTO = this.listaMarcacoes.filter(currentMarcacao => currentMarcacao.pkConsultaDaEntidadeConcatenada === marcacao.pkConsultaDaEntidadeConcatenada)[0];

      if (marcacaoParaSelecionar) {
        marcacaoParaSelecionar.selected = true;
      }
    }
  }

  limparSelecao(): void {

    if (this.listaMarcacoes) {

      this.listaMarcacoes.forEach(currentMarcacao => currentMarcacao.selected = false);
    }

  }

  obterMarcacaoSelecionada(): MarcacaoDTO {

    let marcacaoParaSelecionada: MarcacaoDTO = this.listaMarcacoes.filter(currentMarcacao => currentMarcacao.selected === true)[0];

    return marcacaoParaSelecionada;
  }

  get formControl() {
    return this.formularioDeReenvioComprovanteSelecionarMarcacao.controls;
  }
}
